// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thing-to-reduce[data-v-a2dbd9a6]{display:flex;padding:7px 5px;background-color:#f1f1f4;border-radius:5px}.thing-to-reduce .number[data-v-a2dbd9a6]{display:flex;align-items:center;justify-content:center;min-width:24px;height:24px;margin-right:10px;padding-top:4px;border-radius:50%;background:#ffa43c;color:#fff}", ""]);
// Exports
module.exports = exports;
